import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./userContext";

const PrivateRoute = ({ children }) => {
  if (!localStorage.getItem("token")) {
    return <Navigate to="/signIn" />;
  } else {
    return children;
  }
};

export default PrivateRoute;
